import React from "react";
import { useTranslation } from "react-i18next";
import TagsInput from "react-tagsinput";

const TagsTwo = ({ tags, setTags }) => {
  const { t } = useTranslation();
  const handleChange = (tags) => {
    setTags(tags);
  };

  return (
    <TagsInput
      inputProps={{
        placeholder: t("filter.labels.txt39"),
      }}
      value={tags}
      onChange={handleChange}
      onlyUnique={true}
    />
  );
};

export default TagsTwo;
